import { useMutation } from "@tanstack/react-query";

import { useToasts } from "app/common/hooks";
import { translate } from "app/filters/i18nFilter";
import { createBenchmarkTrackerApi } from "app/pages/benchmark-tracker/services/api";
import type { BenchmarkGranularity } from "app/pages/benchmark-tracker/services/api/constants";

const SUBSCRIBE_TO_DIGEST_MUTATION_KEY = "SUBSCRIBE-TO-DIGEST";

export const useDigestSubscribe = (benchmarkId: string, granularity: BenchmarkGranularity) => {
    const { showErrorToast } = useToasts();

    return useMutation({
        mutationKey: [SUBSCRIBE_TO_DIGEST_MUTATION_KEY],
        mutationFn: () => {
            const api = createBenchmarkTrackerApi();

            return api.report.subscribeToDigest(benchmarkId, granularity);
        },

        onError(error: Error) {
            showErrorToast(translate("common.api.error", { error: error?.message }));
        },
    });
};
